import React, { ReactNode, useMemo } from 'react';
import { heapTrack } from 'src/scripts/utils/helpers';
import { HeapTrackEventsType } from '../../_shared/types';

type Link = {
  href: string;
};

type CallToActionBehavior = Link | 'reload-page';

interface CallToAction {
  text: string;
  behavior: CallToActionBehavior;
}

// Displays a full-page message. This is useful for displaying something other than what was supposed to be displayed.
// E.g. if a page has no items or if an error occurred
const ProminentMessage = ({
  title,
  subtitle,
  callToAction,
  icon,
  heapTrackEvents,
}: {
  title?: string;
  subtitle: string;
  callToAction: CallToAction;
  icon?: () => ReactNode;
  heapTrackEvents?: HeapTrackEventsType;
}) => {
  const callToActionMarkup = useMemo(() => {
    if (callToAction.behavior === 'reload-page') {
      return (
        <button onClick={() => window.location.reload()} className="btn btn-primary btn-block prominent-message__cta">
          {callToAction.text}
        </button>
      );
    }

    return (
      <a
        href={callToAction.behavior.href}
        className="btn btn-primary btn-block prominent-message__cta"
        onClick={
          heapTrackEvents
            ? () => heapTrack(heapTrackEvents.heapEventName, heapTrackEvents.heapEventProperties)
            : undefined
        }
      >
        {callToAction.text}
      </a>
    );
  }, [callToAction, heapTrackEvents]);

  return (
    <div className="prominent-message">
      {icon && <div className="prominent-message__icon">{icon()}</div>}
      {title && <h1 className="h2">{title}</h1>}
      <p className="prominent-message__subtitle">{subtitle}</p>
      {callToActionMarkup}
    </div>
  );
};

export default ProminentMessage;
